import { css, CSSResult } from 'lit'
import { csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

export const style: CSSResult = css`

    :host([fit='auto']),
    :host([fit='square']) {
        display: block;
        width: fit-content;
    }

    csc-order-form-button {
        --cse-loader-color: ${csColorText.white};
    }

    .order-form {
        display: flex;
        gap: ${csSpacing.spacing06};
    }

    .order-form.layout-default {
        flex-direction: row;
        width: 100%;
    }

    .order-form.layout-default cse-form-field {
        flex: 0 0 auto;
    }

    .order-form.layout-default csc-order-form-button {
        flex: 1 1 auto;
    }

    .order-form.layout-vertical {
        flex-direction: column;
        width: 100%;
    }

    .order-form.layout-vertical cse-stepper-input {
        --cse-stepper-input-width: 100%;
        --cse-stepper-input-grid-template-column: min-content minmax(0, 1fr) min-content;
    }
`
